// src/components/ReleaseNotes.tsx
import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Typography, IconButton, Box } from '@mui/material';

interface ReleaseNote {
    title: string;
    items: string[];
}

const releaseNotes: ReleaseNote[] = [
    {
        title: 'ویژگی‌های جدید',
        items: [
            'بانک شاخص',
            'پایش شاخص ها',
            'هدف نهایی و استراتژی',
            'امکان افزودن ایمیل ',
            'امکان جستجو در فرم ها',
            'اضافه شدن فیلدهای جدید به هدف',
            'اضافه شدن فیلدهای جدید به نتایج کلیدی '
        ],
    },
    // {
    //     title: 'تغییرات مهم',
    //     items: [
    //         'تغییر در رنگ درخت بر اساس امتیاز',
    //         '',
    //     ],
    // },
    {
        title: 'بهبودها',
        items: [
            'تغییرات در منوی کناری',
            'بهبود نمایش نمودار فرم نمای کلی',
            'بهبود کاربری فرم ها',
            'امکان ورود به ارزیابی قبل از جلسه در جلسه با دابل کلیک',
            '',
        ],
    },
    // {
    //     title: 'تغییرات مهم',
    //     items: [
    //         '',
    //         '',
    //     ],
    // },
    // {
    //     title: 'ملاحظات',
    //     items: [
    //         '',
    //         '',
    //     ],
    // },
];

const releaseNotes2: ReleaseNote[] = [
    {
        title: 'ویژگی‌های جدید',
        items: [
            'امکان ویرایش نظرات',
            'امکان پاسخ به نظرات دیگران',
            'اضافه شده تعداد در تب های فرم',
            'اضافه شدن تب همکاران در جلسه',
            'امکان ارزیابی با دابل کلیک نتیجه کلیدی',
            'اضافه شدن صفحه BAU به اکسل جلسات',
            'امکان تعیین اولویت نمایش برای اهداف و نتایج کلیدی',
            'اضافه شدن ستون ها جدید به تب وضعیت تیم در جلسه'
        ],
    },
    {
        title: 'تغییرات مهم',
        items: [
            'رفع مشکلات ویرایش BAU',
            'امکان ویرایش  نتیجه در نتایج من',
            'امکان ویرایش  نتیجه در همه نتایج ',  
            'امکان فیلتر نمودن نتایج کلیدی در جلسه',
            'رفع مشکلات ثبت نام'
        ],
    },
    {
        title: 'بهبودها',
        items: [
            'امکان تغییر شرکت در داشبورد',
            'بهبود رابط کاربری صفحه ورود',
            'بهبود رابط کاربری صفحه نظرات',
            'بهبود رابط کاربری کارت های تیم',
            'اضافه شدن ستون های جدید به جدول BAU در جلسه',
        ],
    },
];

const releaseNotes3: ReleaseNote[] = [
    {
        title: 'ویژگی‌های جدید',
        items: [
            'امکان حذف نظرات',
            'امکان حذف و ویرایش پاسخ برای نظرات',
            'اضافه شدن ستون های جدید به مدیریت BAU',
            'نمایش تعداد نظرات جلسات به تفکیک جلسه',
            'نمایش تعداد نظرات ثبت شده در جلسات BAU و OKR',
            'امکان ثبت ضمیمه برای اهداف و BAU',
            'امکان افزودن بیش از یک ضمیمه'
        ],
    },
    {
        title: 'تغییرات مهم',
        items: [
            'رفع مشکلات حذف BAU', 
            'امکان مخفی نمودن ستون ها در بانک و مدیریت شاخص',
        ],
    },
    {
        title: 'بهبودها',
        items: [
            'رفع مشکلات تعداد در فرم ها',
            'رفع مشکلات عدم نمایش نتایج براسا تاریخ شروع و پایان',
            'بهبود نمایش اعداد منفی',
            'بهبود رابط کاربری ضمیمه',
            'رفع مشکل رنگ کارت درخت OKR',
            'اضافه شدن ستون های جدید به جدول BAU در جلسه',
        ],
    },
];
const releaseNotes4: ReleaseNote[] = [
    {
        title: 'ویژگی‌های جدید',
        items: [
            'جلسه همسویی (Alignment)',
            'امکان افزایش و کاهش اندازه ستون در جلسه با کلیک روی ستون Header',
            'امکان افزودن لینک در ضمیمه جلسات',
            'امکان import بانک شاخص با Excel',
            'امکان ارزیابی شاخص با استفاده از Excel',
            'امکان ارزیابی نتایج هر شخص بصورت فیلتر شده در جلسات من'
        ],
    },
    {
        title: 'تغییرات مهم',
        items: [
            'تغییر حداکثر حجم تصویر از 4 مگابایت به 200 کیلو بایت در ضمیمه', 
            'محاسبه امتیاز در کارت استراتژی'
        ],
    },
    {
        title: 'بهبودها',
        items: [
            'امکان کاهش زمان در تایمر جلسه',
            'ثابت کردن اندازه جداول',
            'اضافه شدن عکس پرسنلی روی کارت',
            'اصلاح اطلاعات کارت تیم',
            'نمایش نمودار BAU در جلسه'
        ],
    },
];

const releaseNotes5: ReleaseNote[] = [
    {
        title: 'ویژگی‌های جدید',
        items: [
            'دریافت صورت جلسه',
            'واکنشگرا شدن نسخه وب',
            'گزارش نقشه استراتژی',
            'اضافه شدن نمای جدولی در فرم پرسنل',
            'تعیین انواع وضعیت BAU بر اساس بین حدود و خارج حدود بودن',
            'امکان تعیین تعداد روز مجاز قبل و بعد از دوره برای ثبتOKR و همینطور برای جلسه Check-in جهت ثبت ارزیابی',
            'ایجاد شرح نتیجه کلیدی تکمیل شده با استفاده از عدد شروع و پایان و منطق گزارش دهی و واحد سنجش'
        ],
    },
    {
        title: 'تغییرات مهم',
        items: [
            'امکان مشاهده درخواست یا پیشنهاد های همکاری تیم ها در جلسه همسویی', 
            'امکان ارائه پیشنهاد همکاری براساس هر نتیجه',
            'امکان ارائه درخواست همکاری براساس هر نتیجه'
        ],
    },
    {
        title: 'بهبودها',
        items: [
            'رفع موارد مشکل در جلسه',
            'بهبود رابط کاربری فرم همسویی عمودی',
            'بهبود تایمر جلسات',
            'بهبود تاریخچه نتیجه در جلسه و دسترسی به ضمائم، موانع و توضیحات تمام جلسات دیگر',

        ],
    },
];
const ReleaseNotes: React.FC = () => {
    const [expandedSection, setExpandedSection] = useState<string | null>(null);
    const [expandedSectionn, setExpandedSectionn] = useState<string | null>(null);
    const [expandedSectionnn, setExpandedSectionnn] = useState<string | null>(null);
    const handleToggle = (sectionTitle: string) => {
        setExpandedSection(expandedSection === sectionTitle ? null : sectionTitle);
    }; 
    const handleTogglee = (sectionTitle: string) => {
        setExpandedSectionn(expandedSectionn === sectionTitle ? null : sectionTitle);
    };
    const handleToggleee = (sectionTitle: string) => {
        setExpandedSectionnn(expandedSectionnn === sectionTitle ? null : sectionTitle);
    };

    return (
        <Box>
               <div style={styles.container}>
            <Typography variant="h4" style={styles.title}>
                یادداشت‌های نسخه - نسخه 1.3.6
            </Typography>
            <Typography variant="body1" style={styles.date}>
                <strong>تاریخ انتشار:</strong> 17 آذر 1403
            </Typography>
            {releaseNotes5.map((section, index) => (
                <div key={index} style={styles.section}>
                    <div style={styles.sectionHeader}>
                        <Typography variant="h6" style={styles.sectionTitle}>
                            {section.title}
                        </Typography>
                        <IconButton onClick={() => handleToggleee(section.title)} style={styles.icon}>
                            {expandedSectionnn === section.title ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </div>
                    {expandedSectionnn === section.title && (
                        <ul style={styles.list}>
                            {section.items.map((item, itemIndex) => (
                                <li key={itemIndex} style={styles.listItem}>{item}</li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </div>
            <div style={styles.container}>
            <Typography variant="h4" style={styles.title}>
                یادداشت‌های نسخه - نسخه 1.3.5
            </Typography>
            <Typography variant="body1" style={styles.date}>
                <strong>تاریخ انتشار:</strong> 19 آبان 1403
            </Typography>
            {releaseNotes4.map((section, index) => (
                <div key={index} style={styles.section}>
                    <div style={styles.sectionHeader}>
                        <Typography variant="h6" style={styles.sectionTitle}>
                            {section.title}
                        </Typography>
                        <IconButton onClick={() => handleToggleee(section.title)} style={styles.icon}>
                            {expandedSectionnn === section.title ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </div>
                    {expandedSectionnn === section.title && (
                        <ul style={styles.list}>
                            {section.items.map((item, itemIndex) => (
                                <li key={itemIndex} style={styles.listItem}>{item}</li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </div>
             <div style={styles.container}>
            <Typography variant="h4" style={styles.title}>
                یادداشت‌های نسخه - نسخه 1.3.4
            </Typography>
            <Typography variant="body1" style={styles.date}>
                <strong>تاریخ انتشار:</strong> 1 آبان 1403
            </Typography>
            {releaseNotes3.map((section, index) => (
                <div key={index} style={styles.section}>
                    <div style={styles.sectionHeader}>
                        <Typography variant="h6" style={styles.sectionTitle}>
                            {section.title}
                        </Typography>
                        <IconButton onClick={() => handleTogglee(section.title)} style={styles.icon}>
                            {expandedSectionn === section.title ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </div>
                    {expandedSectionn === section.title && (
                        <ul style={styles.list}>
                            {section.items.map((item, itemIndex) => (
                                <li key={itemIndex} style={styles.listItem}>{item}</li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </div>
            <div style={styles.container}>
            <Typography variant="h4" style={styles.title}>
                یادداشت‌های نسخه - نسخه 1.3.3
            </Typography>
            <Typography variant="body1" style={styles.date}>
                <strong>تاریخ انتشار:</strong> 15 مهر 1403
            </Typography>
            {releaseNotes2.map((section, index) => (
                <div key={index} style={styles.section}>
                    <div style={styles.sectionHeader}>
                        <Typography variant="h6" style={styles.sectionTitle}>
                            {section.title}
                        </Typography>
                        <IconButton onClick={() => handleTogglee(section.title)} style={styles.icon}>
                            {expandedSectionn === section.title ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </div>
                    {expandedSectionn === section.title && (
                        <ul style={styles.list}>
                            {section.items.map((item, itemIndex) => (
                                <li key={itemIndex} style={styles.listItem}>{item}</li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </div>
        <div style={styles.container}>
            <Typography variant="h4" style={styles.title}>
                یادداشت‌های نسخه - نسخه 1.3.2
            </Typography>
            <Typography variant="body1" style={styles.date}>
                <strong>تاریخ انتشار:</strong> 26شهریور 1403
            </Typography>
            {releaseNotes.map((section, index) => (
                <div key={index} style={styles.section}>
                    <div style={styles.sectionHeader}>
                        <Typography variant="h6" style={styles.sectionTitle}>
                            {section.title}
                        </Typography>
                        <IconButton onClick={() => handleToggle(section.title)} style={styles.icon}>
                            {expandedSection === section.title ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </div>
                    {expandedSection === section.title && (
                        <ul style={styles.list}>
                            {section.items.map((item, itemIndex) => (
                                <li key={itemIndex} style={styles.listItem}>{item}</li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </div>
        </Box>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        maxWidth: '800px',
        margin: '20px auto',
        padding: '20px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    },
    title: {
        color: '#333',
        borderBottom: '2px solid #333',
        paddingBottom: '10px',
        marginBottom: '20px',
    },
    date: {
        marginBottom: '20px',
    },
    section: {
        marginTop: '20px',
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
    },
    sectionTitle: {
        color: '#333',
    },
    icon: {
        color: '#333',
    },
    list: {
        listStyle: 'disc',
        margin: '10px 0',
        paddingLeft: '20px',
    },
    listItem: {
        marginBottom: '5px',
    },
};

export default ReleaseNotes;
